export const BRAND_ID = "c26495e9-f41e-4b8d-a442-22ab742563b7";
export const BRAND_NAME = "answerforcewebsite";
export const TREE_COUNTER_URL =
  "https://storage.googleapis.com/setmorewebsite_language_bucket/admin/standard/assets/v2/common/tree-counter.json";
export const IS_LIVE = process.env.NEXT_PUBLIC_APP_MODE === "live";
